// As chart.json holds it: a measure is eight rows of four marks, "1000 0100 0010 0001 ...", a row
// an eighth of the bar and a mark a lane, "1" where an arrow comes.
export type Chart = {
  readonly measures: ReadonlyArray<string>;
};

export type Direction = "left" | "down" | "up" | "right";

export const DIRECTIONS: ReadonlyArray<Direction> = ["left", "down", "up", "right"];

// Eighths in a measure of four beats.
export const ROWS = 8;

// A row's four marks and the space after them.
const ROW_WIDTH = 5;

export type Arrow = {
  readonly at: number;
  readonly lane: number;
  readonly onBeat: boolean;
};

// Every arrow whose moment is in [fromMs, toMs), oldest first and left to right within a moment;
// the chart repeats after its last measure, before the epoch as after it.
export const arrowsBetween = (
  chart: Chart,
  barMs: number,
  fromMs: number,
  toMs: number,
): ReadonlyArray<Arrow> => {
  const rowMs = barMs / ROWS;
  const measures = chart.measures.length;
  const out: Array<Arrow> = [];
  for (let index = Math.floor(fromMs / barMs); index * barMs < toMs; index++) {
    const measure = chart.measures[((index % measures) + measures) % measures];
    for (let row = 0; row < ROWS; row++) {
      const at = index * barMs + row * rowMs;
      if (at < fromMs || at >= toMs) {
        continue;
      }
      for (let lane = 0; lane < DIRECTIONS.length; lane++) {
        if (measure[row * ROW_WIDTH + lane] === "1") {
          out.push({ at, lane, onBeat: row % 2 === 0 });
        }
      }
    }
  }
  return out;
};
